import { BaseModel, type RelationConfig } from './base';

export class Audit extends BaseModel {
  id!: number;
  idCustomer!: number;
  idAudit!: number;
  modelType!: string;
  primaryKey!: string;
  attribute!: string | null;
  oldValue!: any;
  newValue!: any;
  action!: AuditActionType;
  createdAt!: Date;
  updatedAt!: Date;

  static override relations(): RelationConfig {
    return {
      action: { 
        type: Object,
      },
    };
  }

  override objectID(): string {
    return (this.idAudit || this.id)?.toString() || '';
  }

  get label(): string {
    return `${this.modelType} - ${AuditActionLabels[this.action]}`;
  }

  get actionLabel(): string {
    return AuditActionLabels[this.action] || 'Unknown';
  }
}

export enum AuditActionType {
  Create = 0,
  Update = 1,
  Event = 2,
}

export const AuditActionLabels: Record<AuditActionType, string> = {
  [AuditActionType.Create]: 'general.create',
  [AuditActionType.Update]: 'general.update',
  [AuditActionType.Event]: 'api.models.audit.event',
};
